module.exports = __webpack_public_path__ + "static/media/main idea.559810ee.mp3";